import React, { useState, useEffect, useRef } from 'react';
// import { Modal, Button } from 'react-bootstrap';
import { useMarks } from '../../../context/CyamContext';
import { useGrade } from '../../../context/GradeContext';
import {Link} from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { Modal } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import DataTable from './DataTable';
import ReactDOM from 'react-dom';
import AnnualScores from './AnnualScores';
import AnnualTable from './AnnualTable';
import PrintScores from './PrintScores';



const Transcript = () => {



    // Create a new Date object
    const currentDate = new Date();
    // Get the current date components
    const ac_year = currentDate.getFullYear();

    const printWindowRef = useRef(null);

    const [ show, setShow ] = useState(false);
    const [ annualModal, setAnnualModal ] = useState(false);
    const { marks, loadingMarksData, refreshData } = useMarks();
    const { grade } = useGrade();
    const [selectedGrade, setSelectedGrade] = useState('--Select--');
    //get clicked uid-> student-uid
    const [ uid, setUid ] = useState(null);
    const [printArray, setPrintArray] = useState([]);

    const selectOption = (e) => {
        setSelectedGrade(e.target.value);
    }

    const openTranscriptModal = (uid) =>{
        setUid(uid);
        if(marks.length > 0){
            const dataForPrinting = marks.filter(stu => stu.student_uid === uid).filter(exm => exm.te ==='Internal-I')
            setPrintArray(dataForPrinting);
            setShow(true);
        }else{
            setPrintArray(0);
            setShow(true);
        }
    }

    // console.log(uid);

    const closeTranscriptModal = () => {
        setShow(false);
        setUid(null);
    }

    const openAnnualModal = (uid) =>{
        setAnnualModal(true);
        setUid(uid);
    }

    const closeAnnualModal = () => {
        setAnnualModal(false);
        setUid(null);
    }

    function extractUniqueStudents(data) {
        if (data.length === 0) {
            return [];
        }
    
        const noDuplicate = [];
        const uniqueStudentsMap = new Map();
    
        for (const entry of data) {
            const { student_uid, student, section, ac_year } = entry;
            const key = `${student_uid}_${ac_year}`;
    
            if (!uniqueStudentsMap.has(key)) {
                uniqueStudentsMap.set(key, { student_uid, student, section, ac_year });
                noDuplicate.push({ student_uid, student, section, ac_year });
            }
        }
    
        return noDuplicate;
    }
    
    // for single line display 
    let noDuplicate = [];
    if(marks.length > 0){
        noDuplicate = extractUniqueStudents(marks);
    }
   
    let filteredSection = [];
    if(noDuplicate.length > 0 && selectedGrade !=='--Select--'){
        filteredSection = noDuplicate.filter(grade => grade.section === selectedGrade)
    }else {
        filteredSection = noDuplicate; 
    }

    const recordsPage = 10;
    const [currentPage , setCurrentPage] = useState(1);
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;  

    let records = [];
    let npage = 0;
    if(filteredSection.length >0){
        records = filteredSection.slice(firstIndex, lastIndex);
        npage = Math.ceil(filteredSection.length / recordsPage)
    } 
    const number = [...Array(npage + 1).keys()].slice(1)

   
    function prePage (){
        if(currentPage !== 1){
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage (student_id){
        setCurrentPage(student_id);
    }
    
    function nextPage (){
        if(currentPage !== npage){
            setCurrentPage(currentPage + 1)
        }
    }

    // console.log(noDuplicate);

    let hyResult = [];
    if(marks.length >0){
        hyResult = marks.filter(exm => exm.te ==='half-yearly');
    }
   
    // if(noDuplicate.length > 0 && noDuplicate.some(entry => entry.te === 'half-yearly')){
    //     hyResult = noDuplicate.filter(sid => sid.student_uid === '23020359NS2');
    // }
    // if(noDuplicate.length >0){
    //     if (marks.some(entry => entry.te === 'half-yearly')) {
    //         hyResult = marks.filter(suid => suid.student_uid === uid).filter(exm => exm.te ==='half-yearly');
    //     }
    // }
    // console.log(hyResult);

    let fullResult = [];
    if(marks.length >0){
        if (marks.some(entry => entry.te === 'annual')) {
            fullResult = marks.filter(suid => suid.student_uid === uid).filter(exm => exm.ac_year === ac_year);
        }
    }

    // console.log(fullResult);
//     let filteredData = marks.filter(te => te.term_name === tname).filter(cls => cls.class_for === selectedClass);
    // console.log(hyResult);

    const handlePrintHY = () => {
        const printWindow = window.open('', '_blank');
      
        printWindow.document.write('<html><head><title>Printable Receipt</title></head><body>');
      
        // Render the React component inside the print window
        ReactDOM.render(<PrintScores scoreData={printArray} />, printWindow.document.body);
      
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
        closeTranscriptModal();
      };

      const handlePrintAnnual = () => {
        const printWindow = window.open('', '_blank');
      
        printWindow.document.write('<html><head><title>Printable Receipt</title></head><body>');
      
        // Render the React component inside the print window
        ReactDOM.render(<AnnualScores annualData={fullResult} />, printWindow.document.body);
      
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
        closeAnnualModal();
      };

    //Detect control+P key
    useEffect(() => {
        const handleKeyPress = (event) => {
          if ((event.ctrlKey || event.metaKey) && event.key === 'p') {
            event.preventDefault(); // Prevent the default browser print behavior
            customPrintFunction();
          }
        };
    
        document.addEventListener('keydown', handleKeyPress);
    
        return () => {
          document.removeEventListener('keydown', handleKeyPress);
        };
      }, []);
    
      const customPrintFunction = () => {
        console.log('Custom print function triggered');    
        // Open a new window for printing
        printWindowRef.current = window.open('', '_blank');    
        // Check if the print window is valid
        if (printWindowRef.current) {
            printWindowRef.current.document.write('<html><head><title>Printable Receipt</title></head><body>Hi! there</body></html>');
            printWindowRef.current.document.close();

      // Trigger print in the new window
      printWindowRef.current.print();
        } else {
          console.error('Print window is null or not initialized');
        }
      };


  return (
    <>
        <div className="row">
            <div className="col-xl-12">
                <div className="page-title flex-wrap">
                    <div className="input-group search-area mb-md-0 mb-3">
                        <input type="text" className="form-control" placeholder="Search here..." />
                        <span className="input-group-text"><Link to={"#"}>
                            <svg wstudent_idth="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF"/>
                            </svg>
                        </Link></span>
                    </div>
                    <div className='d-flex'>
                        <Form.Select size="sm" style={{width:'120px'}} value={selectedGrade} onChange={selectOption}>
                            {/* <option value="all">---All---</option> */}
                            {grade.map((item, index) => 
                                <option value={item.class_options} key={index}>{item.class_label}</option>
                            )}
                        </Form.Select>
                        <span className='p-2'></span>
                        <button className='btn btn-success' onClick={refreshData} disabled={loadingMarksData}>
                            Refresh Data
                        </button>
                    </div>
                </div>
            </div> 
                            
            <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                <div className="table-responsive full-data pb-20">
                    <div student_id="example-student_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer" student_id="example-student">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>UID</th>
                                    <th>Section</th>
                                    <th>Academic Year</th>
                                    <th className="text-end">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {records.map((item, ind)=>(                                
                                    <tr key={ind}>
                                        <td><span className="text-primary font-w600"> {item.student}</span></td>
                                        <td><h6 className="mb-0">{item.student_uid}</h6></td>
                                        <td><h6 className="mb-0">{item.section}</h6></td>
                                        <td><h6 className="mb-0">{item.ac_year}</h6></td>
                                        
                                        <td>
                                            <div className="d-flex float-end">
                                                <div className="icon-box icon-box-sm bg-light me-2">
                                                <svg width="800px" height="800px" viewBox="0 0 1024 1024" class="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg" onClick={()=>openTranscriptModal(item.student_uid)}><path d="M768 938.666667H170.666667V170.666667h426.666666l170.666667 170.666666z" fill="#42A5F5" /><path d="M853.333333 853.333333H256V85.333333h426.666667l170.666666 170.666667z" fill="#90CAF9" /><path d="M821.333333 277.333333H661.333333V117.333333z" fill="#E1F5FE" /><path d="M499.2 637.866667c0-4.266667 0-8.533333 2.133333-12.8s4.266667-6.4 6.4-10.666667 6.4-4.266667 10.666667-6.4 8.533333-2.133333 12.8-2.133333 10.666667 0 14.933333 2.133333 8.533333 4.266667 10.666667 6.4 4.266667 6.4 6.4 10.666667 2.133333 8.533333 2.133333 12.8 0 8.533333-2.133333 12.8-4.266667 6.4-6.4 10.666666-6.4 4.266667-10.666667 6.4-8.533333 2.133333-14.933333 2.133334-10.666667 0-12.8-2.133334-8.533333-4.266667-10.666667-6.4-4.266667-6.4-6.4-10.666666-2.133333-8.533333-2.133333-12.8z m57.6-66.133334h-49.066667l-8.533333-209.066666h64l-6.4 209.066666z" fill="#1976D2" /></svg>
                                                </div>
                                                <div className="icon-box icon-box-sm bg-light me-2">
                                                    <svg width="800px" height="800px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M27 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H27C28.6569 22 30 20.6569 30 19V5C30 3.34315 28.6569 2 27 2Z" fill="#1565C0"/>
                                                        <path d="M14.09 11.15C14.5183 10.734 14.8128 10.1997 14.9357 9.61538C15.0587 9.03108 15.0044 8.42339 14.78 7.8701C14.5555 7.3168 14.1711 6.84306 13.6758 6.50952C13.1806 6.17598 12.5971 5.9978 12 5.9978C11.4029 5.9978 10.8194 6.17598 10.3242 6.50952C9.82892 6.84306 9.44447 7.3168 9.22002 7.8701C8.99557 8.42339 8.94134 9.03108 9.06426 9.61538C9.18717 10.1997 9.48165 10.734 9.91 11.15C7.68 11.75 6 14.14 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18C7.26522 18 7.51957 17.8946 7.70711 17.7071C7.89464 17.5196 8 17.2652 8 17C8 14.79 9.35 13 11 13H13C14.65 13 16 14.79 16 17C16 17.2652 16.1054 17.5196 16.2929 17.7071C16.4804 17.8946 16.7348 18 17 18C17.2652 18 17.5196 17.8946 17.7071 17.7071C17.8946 17.5196 18 17.2652 18 17C18 14.14 16.32 11.75 14.09 11.15ZM12 7.99999C12.1978 7.99999 12.3911 8.05864 12.5556 8.16852C12.72 8.2784 12.8482 8.43458 12.9239 8.6173C12.9996 8.80003 13.0194 9.0011 12.9808 9.19508C12.9422 9.38906 12.847 9.56724 12.7071 9.70709C12.5673 9.84695 12.3891 9.94219 12.1951 9.98077C12.0011 10.0194 11.8 9.99955 11.6173 9.92387C11.4346 9.84818 11.2784 9.72001 11.1685 9.55556C11.0586 9.39111 11 9.19777 11 8.99999C11 8.73477 11.1054 8.48042 11.2929 8.29288C11.4804 8.10534 11.7348 7.99999 12 7.99999Z" fill="#E64A19"/>
                                                        <path d="M25 8H22C21.7348 8 21.4804 7.89464 21.2929 7.70711C21.1054 7.51957 21 7.26522 21 7C21 6.73478 21.1054 6.48043 21.2929 6.29289C21.4804 6.10536 21.7348 6 22 6H25C25.2652 6 25.5196 6.10536 25.7071 6.29289C25.8946 6.48043 26 6.73478 26 7C26 7.26522 25.8946 7.51957 25.7071 7.70711C25.5196 7.89464 25.2652 8 25 8Z" fill="#E0E0E0"/>
                                                        <path d="M25 12H19C18.7348 12 18.4804 11.8946 18.2929 11.7071C18.1054 11.5196 18 11.2652 18 11C18 10.7348 18.1054 10.4804 18.2929 10.2929C18.4804 10.1054 18.7348 10 19 10H25C25.2652 10 25.5196 10.1054 25.7071 10.2929C25.8946 10.4804 26 10.7348 26 11C26 11.2652 25.8946 11.5196 25.7071 11.7071C25.5196 11.8946 25.2652 12 25 12Z" fill="#E0E0E0"/>
                                                        <path d="M25 16H22C21.7348 16 21.4804 15.8946 21.2929 15.7071C21.1054 15.5196 21 15.2652 21 15C21 14.7348 21.1054 14.4804 21.2929 14.2929C21.4804 14.1054 21.7348 14 22 14H25C25.2652 14 25.5196 14.1054 25.7071 14.2929C25.8946 14.4804 26 14.7348 26 15C26 15.2652 25.8946 15.5196 25.7071 15.7071C25.5196 15.8946 25.2652 16 25 16Z" fill="#E0E0E0"/>
                                                        <path d="M27 24H5C4.20435 24 3.44129 24.3161 2.87868 24.8787C2.31607 25.4413 2 26.2044 2 27C2 27.7956 2.31607 28.5587 2.87868 29.1213C3.44129 29.6839 4.20435 30 5 30H27C27.7956 30 28.5587 29.6839 29.1213 29.1213C29.6839 28.5587 30 27.7956 30 27C30 26.2044 29.6839 25.4413 29.1213 24.8787C28.5587 24.3161 27.7956 24 27 24Z" fill="#37474F"/>
                                                        <path d="M5 2C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H16V2H5Z" fill="#1E88E5"/>
                                                        <path d="M14.09 11.15C14.5183 10.734 14.8128 10.1997 14.9357 9.61538C15.0587 9.03108 15.0044 8.42339 14.78 7.8701C14.5555 7.3168 14.1711 6.84306 13.6758 6.50952C13.1806 6.17598 12.5971 5.9978 12 5.9978C11.4029 5.9978 10.8194 6.17598 10.3242 6.50952C9.82892 6.84306 9.44447 7.3168 9.22002 7.8701C8.99557 8.42339 8.94134 9.03108 9.06426 9.61538C9.18717 10.1997 9.48165 10.734 9.91 11.15C7.68 11.75 6 14.14 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18C7.26522 18 7.51957 17.8946 7.70711 17.7071C7.89464 17.5196 8 17.2652 8 17C8 14.79 9.35 13 11 13H13C14.65 13 16 14.79 16 17V12.23C15.4593 11.7218 14.8042 11.3514 14.09 11.15ZM12 9.99999C11.8022 9.99999 11.6089 9.94134 11.4444 9.83146C11.28 9.72158 11.1518 9.5654 11.0761 9.38267C11.0004 9.19995 10.9806 8.99888 11.0192 8.8049C11.0578 8.61092 11.153 8.43273 11.2929 8.29288C11.4327 8.15303 11.6109 8.05779 11.8049 8.0192C11.9989 7.98062 12.2 8.00042 12.3827 8.07611C12.5654 8.1518 12.7216 8.27997 12.8315 8.44442C12.9414 8.60887 13 8.80221 13 8.99999C13 9.2652 12.8946 9.51956 12.7071 9.70709C12.5196 9.89463 12.2652 9.99999 12 9.99999Z" fill="#FF7043"/>
                                                        <path d="M5 24C4.20435 24 3.44129 24.3161 2.87868 24.8787C2.31607 25.4413 2 26.2044 2 27C2 27.7956 2.31607 28.5587 2.87868 29.1213C3.44129 29.6839 4.20435 30 5 30H16V24H5Z" fill="#455A64"/>
                                                    </svg>
                                                </div>
                                                <div className="icon-box icon-box-sm bg-light">
                                                    <svg width="800px" height="800px" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>openAnnualModal(item.student_uid)}>
                                                        <path d="M23.3 8.40007L21.82 6.40008C21.7248 6.27314 21.6009 6.17066 21.4583 6.10111C21.3157 6.03156 21.1586 5.99693 21 6.00008H11.2C11.0556 6.00007 10.9128 6.03135 10.7816 6.09177C10.6504 6.15219 10.5339 6.24031 10.44 6.35007L8.72 8.35008C8.57229 8.53401 8.49437 8.76424 8.5 9.00008V16.2901C8.50264 18.0317 9.19568 19.7013 10.4272 20.9328C11.6588 22.1644 13.3283 22.8574 15.07 22.8601H16.93C18.6717 22.8574 20.3412 22.1644 21.5728 20.9328C22.8043 19.7013 23.4974 18.0317 23.5 16.2901V9.00008C23.5 8.7837 23.4298 8.57317 23.3 8.40007Z" fill="#FFCC80"/>
                                                        <path d="M29.78 28.38L25.78 23.38C25.664 23.2321 25.5087 23.1198 25.3318 23.0562C25.1549 22.9925 24.9637 22.98 24.78 23.02L16 25L7.22 23C7.03633 22.96 6.84509 22.9725 6.66822 23.0362C6.49134 23.0998 6.336 23.2121 6.22 23.36L2.22 28.36C2.10393 28.5064 2.03117 28.6823 2.00996 28.8679C1.98875 29.0534 2.01994 29.2413 2.1 29.41C2.17816 29.5839 2.30441 29.7319 2.46387 29.8364C2.62333 29.9409 2.80935 29.9977 3 30H29C29.1885 29.9995 29.373 29.9457 29.5322 29.8448C29.6915 29.744 29.819 29.6002 29.9 29.43C29.9801 29.2613 30.0112 29.0734 29.99 28.8879C29.9688 28.7023 29.8961 28.5264 29.78 28.38Z" fill="#01579B"/>
                                                        <path d="M29.29 6.00003L16.29 2.00003C16.0999 1.95002 15.9001 1.95002 15.71 2.00003L2.71 6.00003C2.49742 6.06422 2.31226 6.19735 2.1837 6.37841C2.05515 6.55947 1.99052 6.77817 2 7.00003C1.9917 7.22447 2.0592 7.44518 2.19163 7.62659C2.32405 7.80799 2.5137 7.93954 2.73 8.00003L15.73 11.6C15.906 11.6534 16.094 11.6534 16.27 11.6L29.27 8.00003C29.4863 7.93954 29.6759 7.80799 29.8084 7.62659C29.9408 7.44518 30.0083 7.22447 30 7.00003C30.0095 6.77817 29.9448 6.55947 29.8163 6.37841C29.6877 6.19735 29.5026 6.06422 29.29 6.00003Z" fill="#01579B"/>
                                                        <path d="M11.22 6C11.0756 5.99999 10.9328 6.03127 10.8016 6.09169C10.6704 6.15211 10.5539 6.24023 10.46 6.35L8.74 8.35C8.58509 8.53114 8.49998 8.76166 8.5 9V16.29C8.50264 18.0317 9.19569 19.7012 10.4272 20.9328C11.6588 22.1643 13.3283 22.8574 15.07 22.86H16V6H11.22Z" fill="#FFE0B2"/>
                                                        <path d="M7.22 23C7.03633 22.96 6.84509 22.9725 6.66822 23.0362C6.49134 23.0998 6.336 23.2121 6.22 23.36L2.22 28.36C2.10393 28.5064 2.03117 28.6823 2.00996 28.8679C1.98875 29.0534 2.01994 29.2413 2.1 29.41C2.17816 29.5839 2.30441 29.7319 2.46387 29.8364C2.62333 29.9409 2.80935 29.9977 3 30H16V25L7.22 23Z" fill="#0277BD"/>
                                                        <path d="M15.71 2.00002L2.71 6.00002C2.49742 6.06422 2.31226 6.19734 2.1837 6.3784C2.05515 6.55947 1.99052 6.77817 2 7.00002C1.9917 7.22447 2.0592 7.44518 2.19163 7.62658C2.32405 7.80799 2.5137 7.93954 2.73 8.00002L15.73 11.6C15.8194 11.6146 15.9106 11.6146 16 11.6V2.00002C15.9039 1.98469 15.8061 1.98469 15.71 2.00002Z" fill="#0277BD"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {/* <a href="https://www.flaticon.com/free-icons/academic" title="academic icons">Academic icons created by surang - Flaticon</a> */}
                                {/* <a href="https://www.flaticon.com/free-icons/tour" title="tour icons">Tour icons created by Flat Icons - Flaticon</a> */}
                            </tbody>                                     
                        </table> 
                        <div className="d-sm-flex text-center justify-content-between align-items-center">                           
                            <div className='dataTables_info'>
                                Showing {lastIndex-recordsPage + 1} to{" "}
                                {records.length < lastIndex ? records.length : lastIndex}
                                {" "}of {records.length} entries
                            </div>
                            <div
                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                id="example-student_wrapper"
                            >
                                <Link
                                    className="paginate_button previous disabled"
                                    to="#"                                        
                                    onClick={prePage}
                                >
                                    <i className="fa-solid fa-angle-left" />
                                </Link>
                                <span>                                      
                                    {number.map((n , i )=>(
                                        <Link className={`paginate_button ${currentPage === n ? 'current' :  '' } `} key={i}                                            
                                            onClick={()=>changeCPage(n)}
                                        > 
                                            {n}                                                

                                        </Link>
                                    ))}
                                </span>
                                <Link
                                    className="paginate_button next"
                                    to="#"                                        
                                    onClick={nextPage}
                                >
                                    <i className="fa-solid fa-angle-right" />
                                </Link>
                            </div>
                        </div>             
                    </div>
                </div>  
            </div> 
        </div>
        {/* transcript modal section  */}
        <Modal  onHide={closeTranscriptModal} size="xl" show={show} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Score Transcript</h5>
                        <button type="button" className="btn-close"  onClick={closeTranscriptModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card h-auto">                                        
                                        <div className="card-body">
                                            <DataTable suid={uid} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger light" onClick={closeTranscriptModal}>Close</button>
                        <button type="button" className="btn btn-success light" onClick={handlePrintHY}>Print</button>
                    </div>
                </div>                
            </Modal>
            {/* Annual Full Result   */}
            <Modal  onHide={closeAnnualModal} size="xl" show={annualModal} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Score Transcript</h5>
                        <button type="button" className="btn-close"  onClick={closeAnnualModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card h-auto">                                        
                                        <div className="card-body">
                                            <AnnualTable annualData={fullResult} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger light" onClick={closeTranscriptModal}>Close</button>
                        <button type="button" className="btn btn-success light" onClick={handlePrintAnnual}>Print</button>
                    </div>
                </div>                
            </Modal>
    </> 
  )
}

export default Transcript
